import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './OrgUnitAdminPurchasesValidation';

import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitEntryPurchaseData from '../../../../state/omeMeetOrgUnitEntryPurchase/UseOmeMeetOrgUnitEntryPurchaseData';
import useOmeMeetOrgUnitContactData from '../../../../state/omeMeetOrgUnitContact/UseOmeMeetOrgUnitContactData';
import useOmeMeetOrgUnitAthleteEntryData from '../../../../state/omeMeetOrgUnitAthleteEntry/UseOmeMeetOrgUnitAthleteEntryData';
import useOUAdminEntryContextData from '../../../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';
import useOmeMeetOrgUnitNonAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryData';
import useOmeMeetOrgUnitAthleteEntryRelayRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryRelayRosterEntry/UseOmeMeetOrgUnitAthleteEntryRelayRosterEntryData';
import useMyMeetsFiltersData from '../../../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import useForm from '@usas/ui-web/utils/UseForm';
import ToIntIfInt from '@usas/ui-web/utils/ToIntIfInt';
import { FormatMoneyWithSymbol } from '@usas/ui-web/utils/FormatMoney';

import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
};

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Delete Purchase Item?',
  referenceId: Constants.DEFAULT_ID,
  referenceEntity: '',
  itemDescription: '',
  itemPrice: '',
};

const useOrgUnitAdminPurchases = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState, getOmeMeetOrgUnitEntryInfo } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitContactState, getOmeMeetOrgUnitContacts } = useOmeMeetOrgUnitContactData();
  const { omeMeetOrgUnitAthleteEntryState, getOrgUnitAthleteEntryRoster } = useOmeMeetOrgUnitAthleteEntryData();
  const { omeMeetOrgUnitAthleteEntryRelayRosterEntryState, getOrgUnitAthleteEntryRelayRosterEntry } = useOmeMeetOrgUnitAthleteEntryRelayRosterEntryData();
  const { omeMeetOrgUnitNonAthleteEntryState, getOrgUnitNonAthleteEntryCredentials } = useOmeMeetOrgUnitNonAthleteEntryData();
  const { omeMeetOrgUnitEntryPurchaseState, setOmeMeetOrgUnitEntryPurchaseState, getOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryId,
    postOmeMeetOrgUnitEntryPurchase, deleteOmeMeetOrgUnitEntryPurchase } = useOmeMeetOrgUnitEntryPurchaseData();
  const { oUAdminEntryContextState, setOUAdminEntryContextState } = useOUAdminEntryContextData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const { errorState, formState, handleSubmit, updateFormState, setFormData, setIsDirty
  } = useForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const [state, setState] = useState({ tryRedirect: false, tryGet: false, showPayButton: false });
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_REPORTING);
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_REPORTING);
    }
  };

  const onExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (omeMeetState.route === '') {
      //OME Route
      navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
    }
    else {
      //Meet Route
      setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
      navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
    }
  };


  const onDeletePurchaseItemDetailClicked = (e, purchaseItemDetail) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopUp: true,
      referenceId: purchaseItemDetail.referenceId || Constants.DEFAULT_ID,
      referenceEntity: purchaseItemDetail.referenceEntity || '',
      itemDescription: purchaseItemDetail.itemDescription || '',
      itemPrice: purchaseItemDetail.itemPrice >= 0 ? FormatMoneyWithSymbol(purchaseItemDetail.itemPrice) : ''
    });
  };

  const onDeletePurchaseItem = (e, referenceEntity, referenceId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteOmeMeetOrgUnitEntryPurchase(omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId, referenceEntity, referenceId);
    onModalCanceled();
    setState({ ...state, tryGet: true });
  }

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  function submitTeamEntryAllowed() {
    //Must have at least one entry contact
    if (omeMeetOrgUnitEntryInfoState.objData?.hasEntryContact === false) {
      return false;
    }
    //Must have at least one athlete on roster
    if (omeMeetOrgUnitEntryInfoState.objData?.hasRosterAthlete === false) {
      return false;
    }
    //All athlete events must be approved
    if (omeMeetOrgUnitEntryInfoState.objData?.hasApprovedEvents === false) {
      return false;
    }
    //Number of credential is allowed
    if (omeMeetOrgUnitEntryInfoState.objData?.credentialsAmountAllowed === false) {
      return false;
    }
    //Number of athletes is allowed 
    if (omeMeetOrgUnitEntryInfoState.objData?.rosterAthleteCountAllowed === false) {
      return false;
    }

    return true;
  }

  useEffect(() => {
    const additionalPurchaseWithQuantityOtherThanZero = omeMeetOrgUnitEntryPurchaseState.objData.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: !additionalPurchaseWithQuantityOtherThanZero });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryPurchaseState.objData.additionalPurchase]);

  useEffect(() => {
    setOUAdminEntryContextState({ ...oUAdminEntryContextState, showNav: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    //Get entry contacts if they aren't already loaded
    if (omeMeetOrgUnitEntryInfoState.isObjLoaded === true && omeMeetOrgUnitEntryInfoState?.objData?.omeMeetId &&
      omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetOrgUnitEntryState?.objData?.orgUnitId
      && omeMeetOrgUnitContactState.isArrayLoading !== true && omeMeetOrgUnitContactState.isArrayLoaded !== true) {
      getOmeMeetOrgUnitContacts(omeMeetOrgUnitEntryInfoState.objData?.omeMeetId, omeMeetOrgUnitEntryState.objData?.orgUnitId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitEntryState, omeMeetOrgUnitContactState])

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId) {
      if (omeMeetOrgUnitAthleteEntryState.isArrayLoaded === false && omeMeetOrgUnitAthleteEntryState.isArrayLoading === false
        && omeMeetOrgUnitNonAthleteEntryState.isArrayLoading === false) {
        getOrgUnitAthleteEntryRoster(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
        getOrgUnitNonAthleteEntryCredentials(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitAthleteEntryState, omeMeetOrgUnitNonAthleteEntryState])

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetState.isObjLoaded === true) {
      getOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryId(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, omeMeetState])

  useEffect(() => {
    if (state.tryGet === true && omeMeetOrgUnitEntryPurchaseState.isSaving === false) {
      getOmeMeetOrgUnitContacts(omeMeetOrgUnitEntryInfoState.objData?.omeMeetId, omeMeetOrgUnitEntryState.objData?.orgUnitId);
      getOrgUnitAthleteEntryRoster(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
      getOrgUnitAthleteEntryRelayRosterEntry(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
      getOrgUnitNonAthleteEntryCredentials(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
      getOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryId(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
      getOmeMeetOrgUnitEntryInfo(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
      setState({ ...state, tryGet: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryGet, omeMeetOrgUnitEntryPurchaseState])

  useEffect(() => {
    if (omeMeetOrgUnitEntryPurchaseState.isObjLoaded === true && Object.keys(omeMeetState.objData).length > 0) {
      if (omeMeetOrgUnitEntryPurchaseState.objData.purchaseItem) {
        setFormData({
          ...formState,
        });
        setIsDirty(true);

        const purchaseItemWithQuantityOtherThanZero = omeMeetOrgUnitEntryPurchaseState.objData.purchaseItem?.find(x => x.quantity > 0) ? true : false;
        const additionalPurchaseWithQuantityOtherThanZero = omeMeetOrgUnitEntryPurchaseState.objData.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
        if (purchaseItemWithQuantityOtherThanZero === true || additionalPurchaseWithQuantityOtherThanZero === true) {
          setState({ ...state, showPayButton: true });
        }
        else {
          setState({ ...state, showPayButton: false });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryPurchaseState, omeMeetState.objData])

  useEffect(() => {
    if (state.tryRedirect === true && omeMeetOrgUnitEntryPurchaseState.isSaved === true) {
      if (omeMeetState.route === '') {
        //OME Route
        navigate(EntryNavLinks.OU_ADMIN_PAYMENTS);
      }
      else {
        //Meet Route
        navigate(NavLinks.OU_ADMIN_PAYMENTS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, omeMeetOrgUnitEntryPurchaseState])

  function submitFormCallback() {
    setOUAdminEntryContextState({ ...oUAdminEntryContextState, showNav: false });
    postOmeMeetOrgUnitEntryPurchase(omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId, createOmeMeetOrgUnitEntryPurchaseObject());
    setState({ ...state, tryRedirect: true });
  }

  function createOmeMeetOrgUnitEntryPurchaseObject() {
    const omeMeetOrgUnitEntryPurchaseStateCopy = JSON.parse(JSON.stringify(omeMeetOrgUnitEntryPurchaseState.objData.additionalPurchase));
    return omeMeetOrgUnitEntryPurchaseStateCopy !== null ? omeMeetOrgUnitEntryPurchaseStateCopy : [];
  }

  function onAdditionalPurchaseValueChanged(purchaseItem, value) {
    const omeMeetOrgUnitEntryPurchaseStateCopy = JSON.parse(JSON.stringify(omeMeetOrgUnitEntryPurchaseState.objData));
    const selectedItemIndex = omeMeetOrgUnitEntryPurchaseStateCopy?.additionalPurchase.findIndex(x => x.omeMeetPriceId === purchaseItem.omeMeetPriceId);
    if (selectedItemIndex > -1) {
      const valueInt = ToIntIfInt(value);
      const valueInteger = valueInt ? parseInt(valueInt).toFixed(0) : 0;
      if (valueInt >= 0 && valueInt <= 1000000) {
        const totalAmount = valueInt * omeMeetOrgUnitEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex].amount;
        const totalAmountRounded = totalAmount.toFixed(2);
        omeMeetOrgUnitEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex] = {
          ...omeMeetOrgUnitEntryPurchaseStateCopy.additionalPurchase[selectedItemIndex],
          quantity: valueInteger,
          totalAmount: totalAmountRounded
        }
      }
    }
    setOmeMeetOrgUnitEntryPurchaseState({
      ...omeMeetOrgUnitEntryPurchaseState,
      objData: omeMeetOrgUnitEntryPurchaseStateCopy
    });

    const purchaseItemWithQuantityOtherThanZero = omeMeetOrgUnitEntryPurchaseStateCopy.purchaseItem?.find(x => x.quantity > 0) ? true : false;
    const additionalPurchaseWithQuantityOtherThanZero = omeMeetOrgUnitEntryPurchaseStateCopy.additionalPurchase?.find(x => x.quantity > 0) ? true : false;
    if (purchaseItemWithQuantityOtherThanZero === true || additionalPurchaseWithQuantityOtherThanZero === true) {
      setIsDirty(true);
      setState({ ...state, showPayButton: true });
    }
    else {
      setState({ ...state, showPayButton: false });
    }
  }

  return {
    state,
    omeMeetState,
    omeMeetOrgUnitEntryState,
    omeMeetOrgUnitEntryInfoState,
    omeMeetOrgUnitContactState,
    omeMeetOrgUnitAthleteEntryState,
    omeMeetOrgUnitAthleteEntryRelayRosterEntryState,
    omeMeetOrgUnitNonAthleteEntryState,
    omeMeetOrgUnitEntryPurchaseState,
    oUAdminEntryContextState,
    errorState,
    formState,
    onFormValueChanged: updateFormState,
    handleSubmit,
    onAdditionalPurchaseValueChanged,
    submitTeamEntryAllowed,
    onBackClicked,
    modalState,
    onModalCanceled,
    onDeletePurchaseItemDetailClicked,
    onDeletePurchaseItem,
    onExitButtonClicked
  };
}

export default useOrgUnitAdminPurchases;